import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="8" cy="8" r="2.5" stroke="currentColor" />
        <mask fill="white" id="path-2-inside-1_663_6028">
            <path
                clipRule="evenodd"
                d="M0.869995 8.00008C1.5863 4.85486 4.50845 2.5 8.00437 2.5C11.5002 2.5 14.4223 4.85478 15.1387 7.99992C14.4224 11.1451 11.5002 13.5 8.00433 13.5C4.50847 13.5 1.58636 11.1452 0.869995 8.00008Z"
                fillRule="evenodd"
            />
        </mask>
        <path
            d="M0.869995 8.00008L-0.105038 7.77802L-0.155613 8.00009L-0.105033 8.22216L0.869995 8.00008ZM15.1387 7.99992L16.1137 8.22198L16.1643 7.99991L16.1137 7.77784L15.1387 7.99992ZM1.84503 8.22214C2.4538 5.54908 4.95743 3.5 8.00437 3.5V1.5C4.05947 1.5 0.718798 4.16064 -0.105038 7.77802L1.84503 8.22214ZM8.00437 3.5C11.0513 3.5 13.5548 5.54901 14.1637 8.222L16.1137 7.77784C15.2898 4.16055 11.9492 1.5 8.00437 1.5V3.5ZM14.1637 7.77786C13.5549 10.4509 11.0513 12.5 8.00433 12.5V14.5C11.9492 14.5 15.2899 11.8394 16.1137 8.22198L14.1637 7.77786ZM8.00433 12.5C4.95745 12.5 2.45385 10.451 1.84502 7.778L-0.105033 8.22216C0.718873 11.8395 4.0595 14.5 8.00433 14.5V12.5Z"
            fill="currentColor"
            mask="url(#path-2-inside-1_663_6028)"
        />
    </svg>
);

export default Icon;
